import { RequestService } from '../../../../../common/services/RequestService';
import { API_AUTHORIZATION } from '../../constants';
import { UserAdjustData } from './getUserAdjustData';

export const getUserRequest = async payload => {
  const response = await RequestService.get(
    API_AUTHORIZATION + '/' + payload
  ).then(response => response);
  return {
    data: UserAdjustData(response.data),
  };
};
